import React, { useState } from 'react';
import RegistrarPesajeForm from '../components/Pesajes/RegistrarPesajeForm';
import RegistrarServicioForm from '../components/Reproductivo/RegistrarServicioForm';
import RegistrarParicionForm from '../components/Reproductivo/RegistrarParicionForm';
import RegistrarControlMachoForm from '../components/Machos/RegistrarControlMachoForm';
import RFIDInput from '../components/RFID/RFIDInput';
import { useAuth } from '../context/AuthContext';
import { buscarAnimalOffline } from '../services/offlineHelpers';

const SesionesPage = () => {
  const { user } = useAuth();
  const [tipoEvento, setTipoEvento] = useState('');
  const [rfidAnimal, setRfidAnimal] = useState(null);
  const [rfidSearching, setRfidSearching] = useState(false);
  const [rfidError, setRfidError] = useState('');

  const handleRFIDScan = async (ide) => {
    setRfidSearching(true);
    setRfidError('');
    setRfidAnimal(null);
    try {
      const result = await buscarAnimalOffline(ide, user.establecimiento_id);
      setRfidAnimal(result.animal);
    } catch {
      setRfidError(`No se encontro animal con IDE: ${ide}`);
    } finally {
      setRfidSearching(false);
    }
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-6">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <h1 className="text-xl sm:text-3xl font-bold text-gray-900">Nueva Sesion de Registro</h1>
            <p className="text-gray-600 mt-1 text-sm">
              Registra eventos del rodeo: pesajes, servicios, pariciones, controles
            </p>
          </div>
          {!navigator.onLine && (
            <span className="px-3 py-1.5 bg-amber-100 text-amber-800 rounded-lg text-sm font-bold border border-amber-300" data-testid="offline-badge">
              MODO CAMPO — Sin conexion
            </span>
          )}
        </div>
      </div>

      {!tipoEvento ? (
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {/* Pesajes */}
          <button
            onClick={() => setTipoEvento('pesaje')}
            data-testid="btn-pesaje"
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition border-2 border-transparent hover:border-green-500"
          >
            <div className="text-5xl mb-4">⚖️</div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Pesajes</h3>
            <p className="text-sm text-gray-600">
              Registrar peso, altura cadera y frame
            </p>
            <div className="mt-4 text-xs text-green-600 font-medium">
              ✓ Cálculos automáticos
            </div>
          </button>

          {/* Servicios */}
          <button
            onClick={() => setTipoEvento('servicio')}
            data-testid="btn-servicio"
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition border-2 border-transparent hover:border-blue-500"
          >
            <div className="text-5xl mb-4">💑</div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Servicios</h3>
            <p className="text-sm text-gray-600">
              IATF o servicio natural
            </p>
            <div className="mt-4 text-xs text-blue-600 font-medium">
              ✓ Control de temporada
            </div>
          </button>

          {/* Pariciones */}
          <button
            onClick={() => setTipoEvento('paricion')}
            data-testid="btn-paricion"
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition border-2 border-transparent hover:border-purple-500"
          >
            <div className="text-5xl mb-4">🍼</div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Pariciones</h3>
            <p className="text-sm text-gray-600">
              Registro de nacimientos y destetes
            </p>
            <div className="mt-4 text-xs text-purple-600 font-medium">
              ✓ EP automático
            </div>
          </button>

          {/* Control Machos */}
          <button
            onClick={() => setTipoEvento('control_macho')}
            data-testid="btn-control-macho"
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition border-2 border-transparent hover:border-orange-500"
          >
            <div className="text-5xl mb-4">🐂</div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Control Machos</h3>
            <p className="text-sm text-gray-600">
              Andrología, CE y scores
            </p>
            <div className="mt-4 text-xs text-orange-600 font-medium">
              ✓ CE relativa y ranking
            </div>
          </button>
        </div>
      ) : (
        <div>
          <button
            onClick={() => setTipoEvento('')}
            className="mb-6 px-4 py-2 text-gray-600 hover:text-gray-900 flex items-center space-x-2"
          >
            <span>←</span>
            <span>Volver a selección de evento</span>
          </button>

          {tipoEvento === 'pesaje' && (
            <RegistrarPesajeForm
              onSuccess={() => setTipoEvento('')}
              onCancel={() => setTipoEvento('')}
            />
          )}

          {tipoEvento === 'servicio' && (
            <RegistrarServicioForm
              onSuccess={() => setTipoEvento('')}
              onCancel={() => setTipoEvento('')}
            />
          )}

          {tipoEvento === 'paricion' && (
            <RegistrarParicionForm
              onSuccess={() => setTipoEvento('')}
              onCancel={() => setTipoEvento('')}
            />
          )}

          {tipoEvento === 'control_macho' && (
            <RegistrarControlMachoForm
              onSuccess={() => setTipoEvento('')}
              onCancel={() => setTipoEvento('')}
            />
          )}
        </div>
      )}

      {/* RFID Scanner Panel */}
      {!tipoEvento && (
        <div className="mt-8 bg-gray-900 rounded-xl p-6 text-white" data-testid="rfid-panel">
          <div className="flex items-center space-x-3 mb-4">
            <span className="text-xl">📡</span>
            <div>
              <h3 className="text-lg font-bold">Lector RFID — Tru-Test XRS2i/SRS2i</h3>
              <p className="text-sm text-gray-400">Modo HID (teclado). Escanee un animal para buscarlo en el sistema.</p>
            </div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <RFIDInput
              onScan={handleRFIDScan}
              placeholder="Apunte el lector y escanee, o escriba IDE + Enter..."
            />
          </div>
          {rfidSearching && <p className="text-sm text-gray-400 mt-3">Buscando animal...</p>}
          {rfidError && <p className="text-sm text-red-400 mt-3" data-testid="rfid-error">{rfidError}</p>}
          {rfidAnimal && (
            <div className="mt-4 bg-green-900/40 border border-green-700 rounded-lg p-4" data-testid="rfid-animal-result">
              <p className="text-sm text-green-400 font-semibold mb-2">Animal encontrado:</p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                <div><span className="text-gray-400">VID:</span> <strong>{rfidAnimal.VID}</strong></div>
                <div><span className="text-gray-400">IDE:</span> <strong className="font-mono">{rfidAnimal.IDE}</strong></div>
                <div><span className="text-gray-400">Sexo:</span> <strong>{rfidAnimal.sexo}</strong></div>
                <div><span className="text-gray-400">Categoria:</span> <strong>{rfidAnimal.categoria}</strong></div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SesionesPage;
